import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'padron/pdf'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'padron/pdf'},

    
    {
        path: 'sunat',
        component: LayoutComponent, // 🔥 ¡Necesario para renderizar el layout!
        data: { layout: 'empty' },  // Usa un layout sin menú/sidebar
        children: [
          { 
            path: '', 
            loadChildren: () => import('app/modules/sunat/sunat.module').then(m => m.SunatModule) // ✅ Carga el MÓDULO (no RoutingModule)
          }
        ]
      },
   
   
    
   

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },


    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
            {path: 'invitacion', loadChildren: () => import('app/modules/invitacion/invitacion.module').then(m => m.InvitacionModule)},
            {path: 'seguridad', loadChildren: () => import('app/modules/seguridad/seguridad.module').then(m => m.SeguridadModule)},
            {path: 'padron', loadChildren: () => import('app/modules/patron/patron.module').then(m => m.PatronModule)},
            {path: 'ibi', loadChildren: () => import('app/modules/ibi/ibi.module').then(m => m.IbiModule)},
             {path: 'vehiculo', loadChildren: () => import('app/modules/vehiculo/vehiculo.module').then(m => m.VehiculosModule)},
            {path: 'telegram', loadChildren: () => import('app/modules/telegram/telegram.module').then(m => m.TelegramModule)},
            {path: 'debug', loadChildren: () => import('app/modules/debug/debug.module').then(m => m.DebugModule)},
            
        ]
    },

    
];
